export interface ConfirmSalesOrder {
  salesOrderAndLineNo: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  deliveryDate: string;
  purchaseOrderDetails: string;
}
